import dayjs from 'dayjs'

const UI_DATE_FORMAT = 'YYYY-MM-DD HH:mm'

export const formatDateToUI = (date: string) => {
  return dayjs(date).format(UI_DATE_FORMAT)
}
